// extracted by mini-css-extract-plugin
export default {"LoadingSpinner":"LogOut_LoadingSpinner__-ojms"};